import * as Yup from 'yup';
import { phoneRegExp } from 'globalutils/constants';

export const validationSchema = {
  cameraProvider: Yup.string().when('haveCamera', {
    is: (val) => val === 'yes',
    then: Yup.string().trim().strict(true).required('common.fieldRequiredMessage'),
    otherwise: Yup.string(),
  }),
  insuranceProvider: Yup.string().trim().required('common.fieldRequiredMessage').min(1, 'common.fieldRequiredMessage'),
  endDate: Yup.date().required('common.fieldRequiredMessage'),
  email: Yup.string().email('banner.emailValidation').required('common.fieldRequiredMessage'),
  phone: Yup.string().matches(phoneRegExp, 'common.validNumFormat').required('common.fieldRequiredMessage'),
};
